import { createDomain } from 'effector';

export default createDomain('edit');
